import { FUZE_HEALTH_COLORS } from '../colors';
import { ALTO_COLORS } from '../colors/alto';

const baseIcons = {
  alert: true,
  bank: true,
  bell: true,
  bookmark: true,
  box: true,
  briefcasemedical: true,
  cake: true,
  calendar: true,
  calendarcancel: true,
  calendarcheck: true,
  camera: true,
  cancel: true,
  capsule: true,
  car: true,
  cart: true,
  chart: true,
  checkbox: true,
  checkcircle: true,
  checklist: true,
  checkmark: true,
  chevroncircledown: true,
  chevroncircleup: true,
  chevrondown: true,
  chevronup: true,
  chevronleft: true,
  chevronright: true,
  clock: true,
  close: true,
  closecircle: true,
  copy: true,
  creditcard: true,
  doctor: true,
  doctorplus: true,
  download: true,
  edit: true,
  ellipsish: true,
  ellipsisv: true,
  externallink: true,
  eyeclosed: true,
  eyeopen: true,
  faceid: true,
  filter: true,
  fingerprint: true,
  gear: true,
  handbox: true,
  home: true,
  homelock: true,
  hourglass: true,
  idcard: true,
  info: true,
  injectorpen: true,
  link: true,
  loader: true,
  mail: true,
  mapmarker: true,
  message: true,
  messagequestion: true,
  minus: true,
  paperairplane: true,
  patch: true,
  people: true,
  percent: true,
  phone: true,
  pill: true,
  pills: true,
  pillbottle: true,
  play: true,
  plus: true,
  pluscircle: true,
  pricetag: true,
  questionmark: true,
  radio: true,
  receipt: true,
  rxchart: true,
  search: true,
  settings: true,
  shield: true,
  shieldslash: true,
  signature: true,
  signpaper: true,
  snowflake: true,
  star: true,
  store: true,
  lightning: true,
  suppository: true,
  swap: true,
  sync: true,
  syringe: true,
  testtube: true,
  topical: true,
  towelette: true,
  trash: true,
  truck: true,
  user: true,
  usercircle: true,
  userplus: true,
} as const;

export const ALTO_TO_FUZE_HEALTH_ICON_MAP = {
  alert: 'warning',
  bank: 'account_balance',
  bell: 'notifications_active',
  box: 'box',
  briefcasemedical: 'medical_services',
  calendar: 'calendar_month',
  camera: 'photo_camera',
  cancel: 'cancel',
  capsule: 'pill',
  car: 'directions_car',
  cart: 'shopping_cart',
  checkbox: 'check_box_outline_blank',
  'checkbox-duo': 'check_box',
  checkcircle: 'check_circle',
  checklist: 'checklist',
  checkmark: 'check',
  chevroncircledown: 'expand_circle_down',
  chevroncircleup: 'expand_circle_up',
  chevrondown: 'keyboard_arrow_down',
  chevronleft: 'chevron_left',
  chevronright: 'arrow_forward_ios',
  chevronup: 'keyboard_arrow_up',
  clock: 'alarm_on',
  close: 'close',
  closecircle: 'cancel',
  copy: 'content_copy',
  creditcard: 'credit_card',
  doctor: 'clinical_notes',
  download: 'download',
  edit: 'edit',
  eyeclosed: 'visibility_off',
  eyeopen: 'visibility',
  fingerprint: 'fingerprint',
  handbox: 'hand_package',
  home: 'house',
  homelock: 'lock',
  hourglass: 'hourglass',
  idcard: 'id_card',
  info: 'info',
  injectorpen: 'syringe',
  lightning: 'bolt',
  loader: 'rotate_right',
  mail: 'mail',
  mapmarker: 'location_on',
  message: 'comment',
  minus: 'remove',
  paperairplane: 'send',
  people: 'group',
  percent: 'percent',
  phone: 'call',
  pillbottle: 'medication',
  pills: 'pill',
  play: 'play_circle',
  plus: 'add_2',
  pluscircle: 'add_circle',
  pricetag: 'shoppingmode',
  questionmark: 'help',
  radio: 'radio_button_unchecked',
  'radio-duo': 'radio_button_checked',
  receipt: 'receipt_long',
  rxchart: 'prescriptions',
  search: 'search',
  shield: 'shield',
  shieldslash: 'remove_moderator',
  signature: 'stylus_note',
  signpaper: 'edit_square',
  snowflake: 'ac_unit',
  star: 'star_rate',
  swap: 'sync_alt',
  sync: 'autorenew',
  syringe: 'syringe',
  testtube: 'labs',
  trash: 'delete',
  truck: 'local_shipping',
  user: 'person',
  usercircle: 'account_circle',
  userplus: 'person_add',
} as const;

export const iconDefaultVariant = {
  main: ALTO_COLORS.TEXT_COLORS.PRIMARY,
  duo: ALTO_COLORS.PALETTE.SECONDARY.LIGHT,
};

export const iconColorVariants = {
  primary: {
    ...iconDefaultVariant,
  },
  secondary: {
    main: ALTO_COLORS.TEXT_COLORS.SECONDARY,
    duo: ALTO_COLORS.PALETTE.SECONDARY.LIGHT,
  },
  grey: {
    main: ALTO_COLORS.TEXT_COLORS.GREY,
    duo: ALTO_COLORS.PALETTE.GREYSCALE.DEFAULT,
  },
  disabled: {
    main: ALTO_COLORS.PALETTE.GREYSCALE.DARKER,
    duo: ALTO_COLORS.PALETTE.GREYSCALE.DEFAULT,
  },
  success: {
    main: ALTO_COLORS.TEXT_COLORS.SUCCESS,
    duo: ALTO_COLORS.PALETTE.SUCCESS.LIGHT,
  },
  danger: {
    main: ALTO_COLORS.TEXT_COLORS.DANGER,
    duo: ALTO_COLORS.PALETTE.DANGER.LIGHTER,
  },
  white: {
    main: ALTO_COLORS.TEXT_COLORS.WHITE,
    duo: ALTO_COLORS.PALETTE.GREYSCALE.DARKER,
  },
} as const;

// TODO: verify these colors
export const fuzeHealthIconColorVariants = {
  primary: {
    main: FUZE_HEALTH_COLORS.PALETTE.SECONDARY.DEFAULT,
    duo: FUZE_HEALTH_COLORS.PALETTE.SECONDARY.LIGHT,
  },
  secondary: {
    main: FUZE_HEALTH_COLORS.PALETTE.SECONDARY.DEFAULT,
    duo: FUZE_HEALTH_COLORS.PALETTE.SECONDARY.DEFAULT,
  },
  grey: {
    main: FUZE_HEALTH_COLORS.TEXT_COLORS.GREY,
    duo: FUZE_HEALTH_COLORS.PALETTE.GREYSCALE.DEFAULT,
  },
  disabled: {
    main: FUZE_HEALTH_COLORS.PALETTE.GREYSCALE.DARKER,
    duo: FUZE_HEALTH_COLORS.PALETTE.GREYSCALE.DEFAULT,
  },
  success: {
    main: FUZE_HEALTH_COLORS.TEXT_COLORS.SUCCESS,
    duo: FUZE_HEALTH_COLORS.PALETTE.SUCCESS.LIGHT,
  },
  danger: {
    main: FUZE_HEALTH_COLORS.TEXT_COLORS.DANGER,
    duo: FUZE_HEALTH_COLORS.PALETTE.DANGER.LIGHTER,
  },
  white: {
    main: FUZE_HEALTH_COLORS.TEXT_COLORS.WHITE,
    duo: FUZE_HEALTH_COLORS.PALETTE.GREYSCALE.DARKER,
  },
} as const;

export const iconColorVariantList = Object.keys(iconColorVariants) as (keyof typeof iconColorVariants)[];
export const variantPostfixes = ['small', 'duo'] as const;

export type ColorVariant = keyof typeof iconColorVariants;

export type BaseIconName = keyof typeof baseIcons;
export type DuoIconName = `${BaseIconName}-duo`;
export type SmallIconName = `${BaseIconName}-small`;

export type BaseIconNameWithColors = BaseIconName | `${BaseIconName}-${ColorVariant}`;
export type DuoIconNameWithColors = DuoIconName | `${DuoIconName}-${ColorVariant}`;
export type SmallIconNameWithColors = SmallIconName | `${SmallIconName}-${ColorVariant}`;

export type AltoIconNameWithColors = BaseIconNameWithColors | DuoIconNameWithColors | SmallIconNameWithColors;

// use this type in all external design systems when typing their icon wrapper name props. There should be a separate
// prop that takes ColorVariant, and the icon wrapper should build the name it needs from there.
export type AltoIconName = BaseIconName | DuoIconName | SmallIconName;

export type AltoIconUrl = `https://assets.prod.alto.com/icons/${AltoIconNameWithColors}.svg`;

export const generateIconUrl = (name: AltoIconNameWithColors): AltoIconUrl =>
  `https://assets.prod.alto.com/icons/${name}.svg`;

// loops through all variant types to create a list of all valid icon names
const allIconNames: AltoIconNameWithColors[] = [];
(Object.keys(baseIcons) as BaseIconName[]).forEach((baseIconName) => {
  allIconNames.push(baseIconName);
  variantPostfixes.forEach((variantPostfix) => {
    allIconNames.push(`${baseIconName}-${variantPostfix}`);
    iconColorVariantList.forEach((iconColorVariant) => {
      allIconNames.push(`${baseIconName}-${iconColorVariant}`);
      allIconNames.push(`${baseIconName}-${variantPostfix}-${iconColorVariant}`);
    });
  });
});

export const altoIconToUrlMap = allIconNames.reduce<Record<string, unknown>>((reduced, iconName) => {
  reduced[iconName] = generateIconUrl(iconName);
  return reduced;
}, {}) as unknown as Record<AltoIconNameWithColors, AltoIconUrl>;
